import { CheckIcon } from "lucide-react";
import React, { useState, useEffect } from "react";

const CustomCheckbox = ({ label, onChange, checked }) => {
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    onChange(event.target.checked);
  };

  return (
    <div className="inline-flex items-center">
      <label
        className="relative flex items-center px-2 rounded-[4px] cursor-pointer"
        htmlFor="checkbox"
        tabIndex={0}
      >
        <input
          type="checkbox"
          className="before:content[''] peer relative w-[20px] h-[20px] cursor-pointer appearance-none rounded-[4px] border-2 border-primary-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-secondary-400 before:opacity-0 before:transition-opacity checked:border-secondary-400 checked:bg-secondary-400 checked:before:bg-secondary-400"
          id="checkbox"
          checked={isChecked}
          onChange={handleCheckboxChange}
          aria-label={checked ? `${label} checked` : `${label}`}  
        />
        <span className="absolute text-primary-900 transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100">
          <CheckIcon size={18} className="ml-[1px] mt-[2px] text-primary-900" />
        </span>
      </label>
      {label && (
        <span className="text-primary-900 dark:text-primary-200 paragraph-medium-regular">
          {label}
        </span>
      )}
    </div>
  );
};

export default CustomCheckbox;
